module.exports = __webpack_public_path__ + "static/media/Raggruppa_76.35c0c485.svg";